const routes = [
  {
    path: "/ricevi-le-comunicazioni",
    name: "Communication",
    component: () => import("@/components/category/form-communication.vue"),
    meta: {
      slug: "ricevi-le-comunicazioni"
    }
  }
];

export default routes;
